
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ item.name }}</ion-title>
        <ion-buttons slot="start">
          <ion-button size="small" shape="round" (click)="closeModal()">
            <ion-icon slot="start" name="close"></ion-icon> {{ 'CLOSE_BUTTON_TEXT' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="item-profile ion-text-center" #profilePic [style.background-image]="'url(' + item.profilePic + ')'"></div>

      <div class="item-detail ion-no-padding">
        <h2>{{ item.name }}</h2>
        <p>{{ item.about }}</p>
      </div>
    </ion-content>
  